import {html, css, LitElement} from "../libs/lit.dist.js";
import {copyToClipboard} from "../util/browser.js";
import {successAlert} from "../alerts.js";
import {showErrorPopup} from "../util/errors.js";
import './fa-icon.js';

export class PkCopyBadge extends LitElement {

    static defaultIconType = 'light';
    static defaultIconCollection = 'fa';
    static defaultIcon = 'clone';

    static styles = css`
        :host {
            display: inline-flex;
            padding: var(--padding-y, 0.25rem) var(--padding-x, 0.6rem);
            border-radius: 1.2rem;
            line-height: 1rem;
            background-color: var(--background-color, var(--gray-200));
            color: var(--text-color, var(--gray-900));
            cursor: pointer;
            gap: 0.7rem;
            align-items: center;
        }
        
        fa-icon {
            opacity: 80%;
            font-size: var(--icon-size, 0.7rem);
        }
        
        :host([size="small"]),
        :host([size="sm"]) {
            --padding-y: 0.1rem;
            --padding-x: 0.5rem;
            --icon-size: 0.6rem;
            font-size: var(--fs-nano, 0.6rem);
        }
        
        :host([size="medium"]),
        :host([size="md"])  {
            --padding-y: 0.5rem;
            --padding-x: 1.2rem;
        }
        
        :host([type="warning"]),
        :host([warning]) {
            --background-color: var(--theme-warning-500, var(--warning));
        }
        
        :host([type="success"]),
        :host([success]) {
            --background-color: var(--theme-success-500, var(--success));
            --text-color: var(--white);
        }
                
        :host([type="danger"]),
        :host([danger]) {
            --background-color: var(--theme-danger-500, var(--danger));
            --text-color: var(--white);
        }
                        
        :host([type="info"]),
        :host([info]) {
            --background-color: var(--theme-info-50, var(--blue-300));
        }
                                
        :host([type="primary"]),
        :host([primary]) {
            --background-color: var(--theme-primary-500, var(--primary));
            --text-color: var(--white);
        }
                                        
        :host([type="secondary"]),
        :host([secondary]) {
            --background-color: var(--theme-secondary, var(--secondary));
            --text-color: var(--white);
        }
                                                
        :host([type="dark"]),
        :host([dark]) {
            --background-color: var(--theme-dark, var(--dark));
            --text-color: var(--white);
        }        
                                                        
        :host([type="light"]),
        :host([dark]) {
            --background-color: var(--theme-light, var(--light));
        }        
        
        :host([type="unstyled"]),
        :host([unstyled]) {
            --background-color: transparent;
            --padding-y: 0;
            --padding-x: 0;
        }
    `

    static properties = {
        content: {type: String},
        message: {type: String},
        rel: {type: String},
        icon: {type: String},
        iconType: {type: String},
        iconCollection: {type: String},
    }

    constructor(props) {
        super(props);
        this.message = 'Skopiowano tekst';
        this.iconType = this.constructor.defaultIconType;
        this.iconCollection = this.constructor.defaultIconCollection;
        this.icon = this.constructor.defaultIcon;
    }

    #getContent() {
        if (this.content) {
            if (typeof this.content === 'function') {
                return this.content();
            }
            return this.content;
        }

        if (this.rel) {
            return document.querySelector(this.rel)?.innerText
        }

        const content = [];
        const slottedContent = this.renderRoot.querySelector('slot:not([name])')?.assignedNodes();
        for (let el of slottedContent) {
            if (el.innerText) {
                content.push(String(el.innerText).trim());
            } else if (el.nodeName === '#text' && el.data) {
                content.push(String(el.data).trim());
            }
        }
        return content.join(' ').trim();
    }

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', async (e) => {
            if (e.target.closest('a, button, input, textarea, select')) {
                return;
            }
            try {
                await copyToClipboard(this.#getContent());
                if (this.message) {
                    successAlert(this.message, {
                        useToasts: true,
                        icon: this.icon,
                        iconType: this.iconType,
                        iconCollection: this.iconCollection,
                    });
                }
            } catch (e) {
                showErrorPopup(e, {useToasts: true});
            }
        });
    }

    render() {
        return html`
            <slot name="before"></slot>
            <slot></slot>
            <slot name="after"></slot>
            <slot name="icon">
                <fa-icon type="${this.iconType}" icon="${this.icon}" collection="${this.iconCollection}"></fa-icon>
            </slot>
        `;
    }
}

customElements.define('pk-copy-badge', PkCopyBadge);
